export function MainAccountLayout({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <section className="px-4 py-4 md:px-8 md:py-8 my-10 md:my-16 flex items-start rounded-3xl border border-neutral-200 dark:border-neutral-700">
      {children}
    </section>
  )
}
